import RBush from 'rbush';

import { IInfrastructureRBushItem } from 'shared/map-search/types/infrastructure';
import { makeContextModule } from 'shared/map-search/utils/makeContextModule';

export interface IInfrastructureFeaturesContext {
  rbush: RBush<IInfrastructureRBushItem>;
  infrastructurePointsLayer: YMaps.InfrastructurePointsLayer;
  infrastructureHTMLPointsLayer: YMaps.InfrastructureHTMLPointsLayer;
}

export const {
  Context: InfrastructureFeaturesContext,
  useContext: useInfrastructureFeaturesContext,
  withContext: withInfrastructureFeaturesContext,
} = makeContextModule<IInfrastructureFeaturesContext>({
  contextName: 'InfrastructureFeaturesContext',
});
